import { ROOT } from "../constants";

const initialState = {
  accessToken: null,
  refreshToken: null,
  isLoadingLogin: false,
  error: null,
};

const rootReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case ROOT.LOGIN_REQUEST:
      return {
        ...state,
        accessToken: null,
        refreshToken: null,
        isLoadingLogin: true,
      };
    case ROOT.LOGIN_FAILURE:
      return {
        ...state,
        isLoadingLogin: false,
        error: action.payload,
      };
    case ROOT.LOGIN_SUCCESS:
      return {
        ...state,
        isLoadingLogin: false,
        accessToken: action.payload.accessToken ?? action.payload.access_token,
        refreshToken:
          action.payload.refreshToken ?? action.payload.refresh_token ?? null,
        error: null,
      };
    case ROOT.LOGOUT:
      return {
        isLoadingLogin: false,
        accessToken: null,
        refreshToken: null,
        error: null,
      };
    case ROOT.UPDATE_TOKEN:
      // Backwards-compatible: payload can be either a string accessToken
      // or an object like { accessToken, refreshToken }
      return {
        ...state,
        accessToken:
          typeof action.payload === "string"
            ? action.payload
            : (action.payload?.accessToken ?? action.payload?.access_token),
        refreshToken:
          typeof action.payload === "object" && action.payload
            ? (action.payload.refreshToken ??
              action.payload.refresh_token ??
              state.refreshToken)
            : state.refreshToken,
      };
    default:
      return state;
  }
};

export default rootReducer;
